import { PropsWithChildren } from "react";
import { PopoverContext, PopoverContextValue } from "./PopoverContext";

export function PopoverProvider({
  children,
  ...props
}: PropsWithChildren<PopoverContextValue>) {
  return (
    <PopoverContext.Provider value={props}>{children}</PopoverContext.Provider>
  );
}
